import { coverZodSchema } from "@@/shared/branding/branding-background";
import { brandingIdZodSchema } from "@@/shared/branding/branding-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { storageItemImageIdZodSchema } from "@@/shared/storage-items/storage-item-images/storage-item-image-id";
import { linearGradientZodSchema } from "@@/shared/stylable/background-style";
import { hexColorZodSchema } from "@@/shared/stylable/hex-color/hex-color";
import { hexColorThemeZodSchema } from "@@/shared/stylable/hex-color/hex-color-theme";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const setBrandingDtoZodSchema = z.object({
    _id: brandingIdZodSchema,
    name: translatableZodSchema,
    state: z.enum(["DRAFT", "PUBLISHED"]),
    providerId: providerIdZodSchema,
    colorThemes: z.object({
        darkColorTheme: z.never().optional(),
        lightColorTheme: hexColorThemeZodSchema,
    }),
    storefrontUrl: z.string().url().optional(),

    background: z.object({
        color: hexColorZodSchema,
        textColor: hexColorZodSchema,
        image: storageItemImageIdZodSchema.or(z.string().url()).optional(),
        gradient: linearGradientZodSchema.optional(),
        cover: coverZodSchema.optional(),
    }),
});

type SetBrandingDto = z.infer<typeof setBrandingDtoZodSchema>;

const setBrandingCommandZodSchema = z.object({
    _id: idZodSchema,
    _type: z.literal("SET_BRANDING_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    branding: setBrandingDtoZodSchema,
});

type SetBrandingCommand = z.infer<typeof setBrandingCommandZodSchema>;

const setBrandingDtoCommandFactoryParamsZodObject = setBrandingDtoZodSchema;

type FactoryParams = z.infer<
    typeof setBrandingDtoCommandFactoryParamsZodObject
>;
const setBrandingCommandFactory = (
    branding: FactoryParams,
): SetBrandingCommand => {
    const command: SetBrandingCommand = {
        _id: generateId({ prefix: "set_branding_command__" }),
        _type: "SET_BRANDING_COMMAND",
        _createdAt: nowIsoAndUnix(),
        branding: {
            ...branding,
        },
    };
    return command;
};

export {
    setBrandingCommandFactory,
    setBrandingCommandZodSchema,
    setBrandingDtoCommandFactoryParamsZodObject,
    setBrandingDtoZodSchema,
};
export type {
    SetBrandingCommand,
    FactoryParams as SetBrandingCommandFactoryParams,
    SetBrandingDto,
};
